import { jsx as _jsx } from "react/jsx-runtime";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { useEffect, useMemo } from "react";
import { useLocalStorage } from "usehooks-ts";
import { AdBannerList, useAdBannerQuery } from ".";
export const SearchPageAdBanner = (param)=>{
    let { shape ="default" , position , subject  } = param;
    const { isMobile  } = useWindowDimensions();
    const [currentBannerItem, setCurrentBannerItem] = useLocalStorage("searchPageAdBanner", null);
    const { adBannerResponse  } = useAdBannerQuery({
        position,
        subject
    });
    const bannerList = useMemo(()=>{
        //pc일때는 전체를 리스트에 담고
        //태블릿 일때는 한개만 담아서 보여준다.
        if (!(adBannerResponse === null || adBannerResponse === void 0 ? void 0 : adBannerResponse.items) || adBannerResponse.items.length === 0) return [];
        if (!isMobile) return adBannerResponse.items;
        let itemToDisplay = currentBannerItem;
        if (!itemToDisplay) {
            itemToDisplay = adBannerResponse.items[0];
        } else {
            const currentIndex = adBannerResponse.items.findIndex((item)=>item.id === itemToDisplay.id);
            const nextIndex = currentIndex !== -1 && currentIndex !== adBannerResponse.items.length - 1 ? currentIndex + 1 : 0;
            itemToDisplay = adBannerResponse.items[nextIndex];
        }
        return [
            itemToDisplay
        ];
    }, [
        adBannerResponse === null || adBannerResponse === void 0 ? void 0 : adBannerResponse.items,
        isMobile,
        subject
    ]);
    useEffect(()=>{
        if (bannerList[0] && bannerList[0] !== currentBannerItem) {
            setCurrentBannerItem(bannerList[0]);
        }
    }, [
        bannerList
    ]);
    if (bannerList.length === 0) return;
    return /*#__PURE__*/ _jsx(AdBannerList, {
        position: position,
        children: bannerList.map((banner, index)=>/*#__PURE__*/ _jsx(AdBannerList.Item, {
                id: banner.id,
                link: banner.link,
                imageUrl: banner.imageUrl,
                imageUrlPc: banner.imageUrlPc,
                imageUrlTablet: banner.imageUrlTablet,
                imageUrlMobile: banner.imageUrlMobile,
                mixpanelPosition: "search list"
            }, "adbanner-" + index))
    });
};
